<template>
  <footer>copyright:zsdou.net All Right Reserved</footer>
</template>

<script>
export default {
  name: 'LayoutFooter',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer{
  min-height: 30px;
  vertical-align: middle;
  text-align: center;
}
a {
  text-decoration: none;
}

</style>
